import React, { ReactElement } from 'react';
import { Modal, Form, Input, Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  createWarehouseHandler,
  selectWarehouseLoading,
  setCreateWarehouseModal
} from '../../../../redux/warehouseSlice';

const { Option } = Select;

const CreateWarehouseModal = (): ReactElement => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const loading = useSelector(selectWarehouseLoading);
  const [selectedCountry, setSelectedCountry] = React.useState<string>('CN');

  const okClickedHander = () => {
    form
      .validateFields()
      .then((values) => {
        console.log(values);
        const data = {
          ...values,
          country: selectedCountry
        };
        dispatch(createWarehouseHandler(data));
        dispatch(setCreateWarehouseModal(false));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const closeModalHandler = () => {
    dispatch(setCreateWarehouseModal(false));
  };

  const countryChangeHandler = (value: string) => {
    setSelectedCountry(value);
  };

  return (
    <Modal
      width={600}
      bodyStyle={{
        minHeight: '300px',
        maxHeight: '1000px',
        overflowY: 'auto',
        margin: '10px 50px'
      }}
      visible
      centered
      closable={false}
      title="Create Warehouse"
      onOk={okClickedHander}
      onCancel={closeModalHandler}
      okButtonProps={{
        loading
      }}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: 'Please input warehouse name!' }]}
        >
          <Input placeholder="Name" />
        </Form.Item>
        <Form.Item label="Company" name="company">
          <Input placeholder="Company" />
        </Form.Item>
        <Form.Item label="Phone" name="phone">
          <Input placeholder="phone" />
        </Form.Item>
        <Form.Item label="Email" name="email">
          <Input placeholder="Email" />
        </Form.Item>
        <Form.Item
          label="Address1"
          name="address1"
          rules={[{ required: true, message: 'Please input address1!' }]}
        >
          <Input placeholder="Address1" />
        </Form.Item>
        <Form.Item label="Address2" name="address2">
          <Input placeholder="Address2" />
        </Form.Item>
        <Form.Item
          label="City"
          name="city"
          rules={[{ required: true, message: 'Please input warehouse city!' }]}
        >
          <Input placeholder="City" />
        </Form.Item>
        <Form.Item
          label="State"
          name="state"
          rules={[{ required: true, message: 'Please input warehouse state!' }]}
        >
          <Input placeholder="State" />
        </Form.Item>
        <Form.Item
          label="Country"
          name="country"
          rules={[{ required: true, message: 'Please input warehouse country!' }]}
        >
          <Select placeholder="Country" optionLabelProp="label" onChange={countryChangeHandler}>
            <Option key="CN" value="CN" label="China">
              <div className="demo-option-label-item">
                <span role="img" aria-label="China">
                  🇨🇳
                </span>
                China (中国)
              </div>
            </Option>
            <Option key="US" value="US" label="United States">
              <div className="demo-option-label-item">
                <span role="img" aria-label="United States">
                  🇺🇸
                </span>
                United States (美国)
              </div>
            </Option>
          </Select>
        </Form.Item>
        <Form.Item
          label="Zip"
          name="zip"
          rules={[{ required: true, message: 'Please input warehouse zip!' }]}
        >
          <Input placeholder="Zip" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateWarehouseModal;
